import React from 'react';
import { Linkedin } from 'lucide-react';

export const LINKEDIN_URL = 'https://www.linkedin.com/in/nabil-hamid-45b25056/';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-white/5">
      <div className="page flex flex-col gap-4 py-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-slate-400">
          © {currentYear} Nabil Hamid. All rights reserved.
        </p>
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-slate-300 transition-colors duration-150 ease-out hover:text-sky-300"
        >
          <Linkedin size={16} strokeWidth={1.75} />
          LinkedIn
        </a>
      </div>
    </footer>
  );
};

export default Footer;
